( function( $ ) {
  if ( $( '.__thumbnail_slider' ).length > 0  ) {
    $( '.__thumbnails' ).slick( {
      slidesToShow  : 3,
      autoplaySpeed : 4000,
      lazyLoad      : "progressive",
      speed         : 600,
      infinite: false,
      cssEase       : "cubic-bezier(0.87, 0.03, 0.41, 0.9)",
      prevArrow     : '<button type="button" class="slick-prev"></button>',
      nextArrow     : '<button type="button" class="slick-next"></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    } );

    $( window ).on( 'resize', function() {
      $( '.lb-close' ).trigger( 'click' );
    } );

    lightbox.option( {
      'disableScrolling': true,
      'wrapAround'      : true
    } );
  }
} ) ( jQuery );